import { useState } from "react";
import "@/App.css";
import axios from "axios";
import { toast, Toaster } from "sonner";
import { MagicalBackground } from "@/components/MagicalBackground";
import { StartScreen } from "@/components/StartScreen";
import { LoadingScreen } from "@/components/LoadingScreen";
import { ResultReport } from "@/components/ResultReport";
import { Footer } from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [stage, setStage] = useState("start");
  const [result, setResult] = useState(null);
  const [tierName, setTierName] = useState("");

  const handleSubmit = async (form) => {
    setTierName(form.name);
    setStage("loading");
    try {
      const { data } = await axios.post(`${API}/analyse/start`, form);
      pollJob(data.job_id);
    } catch (e) {
      console.error(e);
      toast.error("Die Analyse konnte nicht gestartet werden. Bitte versuche es erneut.");
      setStage("start");
    }
  };

  const pollJob = (jobId) => {
    let shownText = false;
    let attempts = 0;
    const interval = setInterval(async () => {
      attempts += 1;
      if (attempts > 50) {
        clearInterval(interval);
        if (!shownText) {
          toast.error("Die Analyse dauert ungewöhnlich lange. Bitte versuche es erneut.");
          setStage("start");
        }
        return;
      }
      try {
        const { data } = await axios.get(`${API}/analyse/status/${jobId}`);
        if ((data.status === "text_done" || data.status === "done") && data.result && !shownText) {
          shownText = true;
          setResult(data.result);
          setStage("result");
          window.scrollTo(0, 0);
        }
        if (data.status === "done") {
          setResult(data.result);
          clearInterval(interval);
        }
        if (data.status === "error") {
          clearInterval(interval);
          toast.error("Die Analyse konnte nicht erstellt werden. Bitte versuche es erneut.");
          setStage("start");
        }
      } catch (e) {
        console.error(e);
      }
    }, 3000);
  };

  const handleReset = () => {
    setResult(null);
    setStage("start");
    window.scrollTo(0, 0);
  };

  return (
    <div className="App magic-bg min-h-screen relative">
      <MagicalBackground />
      <Toaster position="top-center" richColors />
      {stage === "start" && <StartScreen onSubmit={handleSubmit} />}
      {stage === "loading" && <LoadingScreen name={tierName} />}
      {stage === "result" && result && <ResultReport data={result} onReset={handleReset} />}
      {stage !== "loading" && <Footer />}
    </div>
  );
}

export default App;
